// The private documents-bucket host shape, defined once and composed into the two regexes that
// depend on it — the classifier in utils/assets.ts (DOCUMENTS_BUCKET_RE) and the markdown scanner
// in hooks/useResolvedMarkdown.ts (PRIVATE_URL_SCAN). Keeping it in one place means the two can
// never silently drift apart: a divergence would make the scanner miss URLs the classifier still
// treats as private (images 403) or vice-versa (dead download links).
//
// Kept as a plain string (not a RegExp) with no runtime imports so both consumers can splice it
// into their own full pattern — anchored + capturing on the classifier side, global + path-aware
// on the scanner side — and so it stays trivially unit-testable.
//
// Matches: scheme + optional path-style S3 prefix + the bucket host, with the bucket host itself
// in a capturing group (the classifier relies on it; the scanner runs with `g`, which ignores
// capture groups, so the group is harmless there).
export const DOCUMENTS_BUCKET_URL_PREFIX =
  'https?:\\/\\/(?:s3(?:[.-][a-z0-9-]+)?\\.amazonaws\\.com\\/)?(documents(?:-[a-z0-9]+)?\\.hopdrive\\.com)';
